import { render, staticRenderFns } from "./CreateUsers.vue?vue&type=template&id=0b61e7e1&scoped=true&"
import script from "./CreateUsers.vue?vue&type=script&lang=js&"
export * from "./CreateUsers.vue?vue&type=script&lang=js&"
import style0 from "./CreateUsers.vue?vue&type=style&index=0&id=0b61e7e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b61e7e1",
  null
  
)

export default component.exports